import { render, staticRenderFns } from "./ICSFeedButton.vue?vue&type=template&id=73d25875"
import script from "./ICSFeedButton.vue?vue&type=script&lang=js"
export * from "./ICSFeedButton.vue?vue&type=script&lang=js"
import style0 from "./ICSFeedButton.vue?vue&type=style&index=0&id=73d25875&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports